module.exports = __webpack_public_path__ + "img/Jill.576749e8.jpg";